<template>
  <div v-if="totalItems > 0" id="element" class="confirmation-container">

    <notification-modal ref="notificationModal" />

    <pickup-time-changed-confim-modal ref="pickupTimeConfirmModal"/>

    <div class="hidden-element">
      <hr />
    </div>
    <h4>Bekreftelse</h4>
    <div class="confirmation-wrapper">
      <div class="customer-info-form">
        <a-form-model
          ref="orderInfoRuleForm"
          :model="orderInfoForm"
          :rules="orderInfoRules"
        >
          <a-form-model-item
            label="Navn"
            ref="customerName"
            prop="customerName"
          >
            <a-input
              allow-clear
              v-model="orderInfoForm.customerName"
              @blur="() => { $refs.customerName.onFieldBlur();}"
            />
          </a-form-model-item>

          <a-form-model-item
            label="Email"
            ref="customerEmail"
            prop="customerEmail"
          >
            <a-input allow-clear 
                    v-model="orderInfoForm.customerEmail" 
                    @blur="() => { $refs.customerEmail.onFieldBlur();}"
            />
          </a-form-model-item>

          <a-form-model-item
            label="Mobilnummer"
            ref="customerPhone"
            prop="customerPhone"
          >
            <phone-input v-model="orderInfoForm.customerPhone" 
                        @blur="() => { $refs.customerPhone.onFieldBlur();}"
            />
          </a-form-model-item>

          <br />
          <a-form-model-item
            label="Beregnet hentetid"
            prop="chosenDuration"
          >
            <a-time-picker
              format="HH:mm"
              :minuteStep="5"
              @change="handlePickupTimeOnChange"
              :disabledHours="this.getDisabledHours"
              hideDisabledOptions
              inputReadOnly
              v-model="orderInfoForm.pickupTime"
              :disabled="orderInfoForm.asap"
            />
            <a-checkbox v-model="orderInfoForm.asap" @change="handleASAPChanged(orderInfoForm.asap)">
                ASAP
            </a-checkbox>
            
          </a-form-model-item>

          <a-form-model-item label="Noe spesielt?" prop="comment">
            <a-textarea
              v-model="orderInfoForm.comment"
              class="textarea"
              :rows="4"
              placeholder="Kommenter her"
            />
          </a-form-model-item>
        </a-form-model>
      </div>
      <br />
      <div
        style="display:flex; justify-content: space-around;padding-bottom: 10px;"
      >
        <button class="blk-button btn-confirm" @click="handleBtnCheckout">
          Til betaling
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import Moment from 'moment'
import { LOADING_EVENT } from "../../events/eventsSource";
import { mapState, mapGetters } from "vuex";
import PhoneInput from "../../components/inputs/PhoneInput.vue";
import TimeFormatter from "../../commons/TimeFormatter";
import { RedirectCheckout } from "@bambora/checkout-sdk-web";
import cartStorage from "../../storage/cart";
import restaurantStorage from "../../storage/restaurants";
import customerStorage from "../../storage/customer"
import NotificationModal from "../../components/modals/NotificationModal.vue";
import PickupTimeChangedConfimModal from "../../components/modals/PickupTimeChangedConfimModal.vue";

export default {

  inject: ["eventBus"],
  
  components: {
    PhoneInput,
    NotificationModal,
    PickupTimeChangedConfimModal
  },
  computed: {
    ...mapState({
      waitingTimeRanges: state => state.restaurants.waitingTimeRanges,
      disabledHours: state => state.restaurants.disabledHours,
      estimatedPickupTime : state => state.carts.estimatedPickupTime
    }),
    ...mapGetters({
      totalItems: "cart/itemsCount"
    })
  },
  data() {
    let checkDuration = (rule, value, callback) => {
      console.log('checkDuration is called')
      console.log(this.orderInfoForm)
      if (!this.orderInfoForm.isPickupTimeValid) {
        console.log('pickup time is not valid!')
        
        // callback(
        //   new Error("OPS! Vi kan ikke levere bestillingen din på det tidspunktet")
        // );
        this.$notification.open({
          message: "OPS! Vi kan ikke levere bestillingen din på det tidspunktet",
          duration: 4.5,
          icon: <a-icon type="clock-circle" />
        });
        this.updatePickupTime();
        callback();
      } else {
        console.log('pickup time is valid!')
        callback();
      }
    };
    let checkPhoneNumber = (rule, value, callback) => {
      if (
        this.orderInfoForm.customerPhone.length === 8 ||
        this.orderInfoForm.customerPhone.length === 0
      ) {
        callback();
      } else {
        callback(new Error("Telefonnummer er ikke gyldig!"));
      }
    };
    return {
      pickupTimeChangedIntervalId : null,
      isDisabledForPickupTime: true,
      minWaitingTime: 0,
      currentWaitingTime : 0,
      currentTime: "",
      estimatedTime : 0,
      timeOut : 2,
      toTime : '',
      orderInfoForm: {
        customerName: "",
        customerEmail: "",
        customerPhone: "",
        waitingTime: 0,
        pickupTime: null,
        isPickupTimeValid: true,
        comment: "",
        asap : false
      },
      orderInfoRules: {
        customerName: [
          {
            required: true,
            message: "Vennligst skriv inn navnet ditt",
            trigger: "blur"
          },
          {
            min: 2,
            message: "Må være mer enn 2 tegn",
            trigger: "blur"
          }
        ],
        customerEmail: [
          { type: "email", message: "Epost er ikke gyldig", trigger: "blur" }
        ],
        customerPhone: [{ validator: checkPhoneNumber, trigger: "blur" }],
        chosenDuration: [{ validator: checkDuration, trigger: "change" }]
      }
    };
  },
  
  methods: {
    resetEstimatedPickupTime() {
      
      //
      //Check if selected pickup time is valid
      //
      let currentWaitingTime = this.$store.getters['orderManager/minDuration'];
      let earliestPickupTime = Moment();
      earliestPickupTime.add(currentWaitingTime, 'm');
      earliestPickupTime.second(0);
      if (this.orderInfoForm.pickupTime <= earliestPickupTime) {
        this.updatePickupTime();
        this.$notification.open({
          message: "Beregnet hentetid er oppdatert",
          duration: 4.5,
          icon: <a-icon type="clock-circle" />
        });
      }
      else {
        console.log('Do not need to update pickup time!');
      }
      
    },

    handleASAPChanged(e) {
      
      if(e === true) {
        console.log()
        this.updatePickupTime();
      }
    },

    updatePickupTime() {
      let minWaitingTime = this.$store.state.orderManager.currentWaitingTime;
      let maxWaitingTime = this.$store.state.orderManager.maxWaitingTime;
      this.$store.commit('cart/UPDATE_ESTIMATED_PICKUPTIME_STATE', {'minWaitingTime' : minWaitingTime, 'maxWaitingTime' : maxWaitingTime});
      this.orderInfoForm.isPickupTimeValid = true;
      this.orderInfoForm.pickupTime = this.$store.state.cart.pickupTime;
    },

    handlePickupTimeOnChange(time) {
      if (time != null) {
        let currentWaitingTime = this.$store.getters['orderManager/minDuration'];
        let earliestPickupTime = Moment();
        earliestPickupTime.add(currentWaitingTime, 'm');
        earliestPickupTime.second(0);
        if (time.isSameOrAfter(earliestPickupTime)) {
          console.log('time is valid')
          this.orderInfoForm.isPickupTimeValid = true;
          this.orderInfoForm.pickupTime = time
        }
        else {
          console.log('time is not valid')
          this.orderInfoForm.isPickupTimeValid = false;
        }
      }
      else {
        this.updatePickupTime();
      }
      

    },
    getDisabledHours() {
      return this.$store.state.restaurants.disabledHours;
    },
    handleBtnCheckout() {
      //this.$modal.show("add-on-sale");
      this.$loading(true);
      if (this.$store.getters["restaurants/canOrderNow"] >= 0) {
        setTimeout(() => { this.$loading(false) }, 1000);
        this.onSubmit();
      }
      else {
        this.$loading(false);
        this.$refs.notificationModal.showModal();
      }
    },

    onSubmit() {
      console.log("onSubmit is called!!!");
      this.$refs.orderInfoRuleForm.validate(async valid => {
        if (valid) {
          console.log("Valid!!!");
          this.eventBus.$emit(LOADING_EVENT, {});
          //await this.$store.dispatch("restaurants/getCurrentLocalTimeAction");
          
          let paymentInfo = {
            restaurantId: this.$store.state.restaurants.currentRestaurantId,
            amount: this.$store.getters["cart/totalPrice"] * 100,
            currency: "NOK",
            cart: this.$store.getters["cart/itemsInCart"],
            customerName: this.orderInfoForm.customerName,
            email: this.orderInfoForm.customerEmail.toLowerCase(),
            phoneNumber: this.orderInfoForm.customerPhone.replace(/\s/g, ""),
            comment: this.orderInfoForm.comment,
            waitingTime : this.$store.state.cart.estimatedTime,
            pickupTime: TimeFormatter.timeToString(TimeFormatter.formatTime(this.orderInfoForm.pickupTime))
          };
          //console.log(paymentInfo);
          await this.$store.dispatch("payment/getSessionTokenWithAnonymousOrderAction",paymentInfo);
          //await this.$store.dispatch("payment/getSessionTokenTestAction",paymentInfo);
          //
          //store cart and restaurant information
          //
          let currentRestaurantId = this.$store.state.restaurants.currentRestaurantId;
          restaurantStorage.storeCurrentRestaurant(currentRestaurantId);
          cartStorage.storeCart(currentRestaurantId, this.$store.getters[(currentRestaurantId, "cart/storedItems")]);

          //
          //redirect to payment domain
          //
          console.log('payment')
          //console.log(this.$store.state.payment.sessionToken)
          new RedirectCheckout(this.$store.state.payment.sessionToken);
          //this.$router.push("/checkoutcancel");
        } else {
          console.log("Invalid!!!");
        }
      });
    }
  },

  async created() {

    if (this.$store.getters["cart/itemsCount"] > 0) {

      let restaurantId = this.$store.state.restaurants.currentRestaurantId;
      await this.$store.dispatch("orderManager/getOrderManagerStateAction", { restaurantId });
      await this.$store.dispatch("restaurants/getCurrentLocalTimeAction");

      //
      //init estimated pickup time
      //

      let minWaitingTime = this.$store.state.orderManager.currentWaitingTime;
      let maxWaitingTime = this.$store.state.orderManager.maxWaitingTime;
      this.$store.commit('cart/UPDATE_ESTIMATED_PICKUPTIME_STATE', {'minWaitingTime' : minWaitingTime, 'maxWaitingTime' : maxWaitingTime});
      this.orderInfoForm.pickupTime = this.$store.state.cart.pickupTime;

      this.pickupTimeChangedIntervalId = setInterval(this.resetEstimatedPickupTime, this.timeOut * 60 * 1000);

      //
      //load order info 
      //
       
      this.orderInfoForm.customerName = this.$store.state.cart.orderInfo.customerName;
      this.orderInfoForm.customerEmail = this.$store.state.cart.orderInfo.email;
      this.orderInfoForm.customerPhone = this.$store.state.cart.orderInfo.phoneNumber;
      this.orderInfoForm.comment = this.$store.state.cart.orderInfo.comment;
      
    } 
  },

  destroyed() {
    if(this.pickupTimeChangedIntervalId !== null) {
      clearInterval(this.pickupTimeChangedIntervalId);
    }
  }
};
</script>

<style lang="scss">
$desktop: 1200px;
$laptop: 1024px;
$tablet: 768px;
$mobile: 480px;

.hidden-element {
  @media (max-width: $mobile) {
    height: 64px;
    & hr {
      border-bottom: 1px solid #c5c5c5;
      box-shadow: 0 20px 20px -20px #333;

      border: none;
      height: 43px;
      position: relative;
    }
  }
}

hr {
  @media (min-width: $mobile) {
    display: none;
  }
}
.confirmation-error {
  border: red;
}

.confirmation-container {
  @media (max-width: $mobile) {
    position: relative;
    top: 49px;
  }

  & h4 {
    @media (min-width: $mobile) {
      display: none;
    }
    font-size: 20px;
  }
}
.confirmation-wrapper {
  background-color: whitesmoke;
  border-radius: 8px;
  border: 1px solid #e3e3e3;
  margin-top: 30px;
  height: fit-content;
  position: sticky;
  top: 90px;
  font-family: Bebas;
  letter-spacing: 1px;
  transition: box-shadow 0.3s;
  margin-top: 30px;

  @media (max-width: $mobile) {
    top: initial;
    position: initial;
    margin: 50px 25px 50px 25px;
  }
}
.confirmation-wrapper:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}

.order-comment {
  padding: 15px;
  font-size: 18px;
}
.textarea {
  height: 150px;
  width: 300px;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  outline: none;
  transition: 0.3s;

  &:focus {
    border: 1px solid rgba(0, 0, 0, 0.1);

    transition: 0.3s;
  }
}

.order-delivery-form {
  padding: 15px;

  & div {
    margin-bottom: 10px;
  }
}
.customer-info-form {
  padding: 15px;
  & input {
    padding: 15px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    margin-right: 15px;
    transition: 0.3s;
  }

  & input:focus {
    border: 1px solid rgba(0, 0, 0, 0.1);
    outline: none;
    transition: 0.3s;
  }
}
.btn-confirm {
  font-size: 20px;
  padding: 10px;
  width: 90%;
}

.ant-form-item-required::before {
  display: none;
}
.ant-form-item {
  margin-bottom: 0 !important;
}

.checkbox-style {
  padding: 0 0 0 8px;
}
.ant-checkbox-wrapper {
  padding-left: 5px;
}
.ant-checkbox + span {
  padding-right: 0;
  padding-left: 0;
}
textarea.ant-input {
  letter-spacing: 1px;
}

.ant-form label {
  font-size: 18px;
  font-weight: initial;
}
</style>
